module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Clients_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "clients-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "client-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getClientData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "client-management-create-button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Clients_Create')
    },
    on: {
      "click": function($event) {
        (_vm.selectedClient = -1), _vm.openEditClientDialog('create')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedClient == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Clients_Read')
    },
    on: {
      "click": function($event) {
        return _vm.openEditClientDialog('edit')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0002) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedClient == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Create')
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = true), (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("playlist_add")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0006) + "\n        ")]), _vm._v(" "), (_vm.feature.isEnabled('audi_importers')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "client-management-importer-button"
    },
    on: {
      "click": function($event) {
        _vm.showImportersModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0118) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearch",
      "placeholder": _vm.lang.C0007
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.filterClientData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0008))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == -1
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, -1)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.C0009))])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.filteredClientData.length || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0010))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.filteredClientData.length || _vm.selectedPage == _vm.numberOfPages(),
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0011))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "clientsTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredClientData.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "clientsTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0119))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('id')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0012) + "\n                "), (_vm.sortField == 'id' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'id' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "38%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('name')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0013) + "\n                "), (_vm.sortField == 'name' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'name' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "18%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('address')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0014) + "\n                "), (_vm.sortField == 'address' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'address' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('city')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0015) + "\n                "), (_vm.sortField == 'city' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'city' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('region')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0016) + "\n                "), (_vm.sortField == 'region' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'region' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('postalcode')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0017) + "\n                "), (_vm.sortField == 'postalcode' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'postalcode' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('country')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.C0018) + "\n                "), (_vm.sortField == 'country' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'country' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.clientDataOnCurrentPage), function(client) {
    return _c('tr', {
      key: client.ClientId,
      class: {
        info: client.ClientId == _vm.selectedClient
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedClient = client.ClientId
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed('LoopOp_Clients_Read') ||
            _vm.openEditClientDialog('edit')
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(client.ClientId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "38%"
      }
    }, [_vm._v(_vm._s(client.ClientName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(client.ClientAddress))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(client.ClientCity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(client.ClientState_Region))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(client.ClientPostalCode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(client.ClientCountry))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editClient",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n              ×\n            ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.editClientDialogData.dialogTitle))])]), _vm._v(" "), (
    typeof _vm.editClientDialogData.clientData.ClientId != 'undefined'
  ) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.lang.C0019) + ":\n                " + _vm._s(_vm.editClientDialogData.clientData.ClientId))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0020))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputClientName"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0021) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClientDialogData.clientData.ClientName),
      expression: "editClientDialogData.clientData.ClientName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputClientName",
      "name": "inputClientName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editClientDialogData.clientData.ClientName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputClientName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputClientName')),
      expression: "inputHasError('inputClientName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0090))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0022))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientAddress
      ),
      expression: "\n                            editClientDialogData.clientData.ClientAddress\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientAddress
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientAddress2
      ),
      expression: "\n                            editClientDialogData.clientData.ClientAddress2\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientAddress2
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClientDialogData.clientData.ClientCity),
      expression: "editClientDialogData.clientData.ClientCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity"
    },
    domProps: {
      "value": (_vm.editClientDialogData.clientData.ClientCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0027))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientCountry
      ),
      expression: "\n                            editClientDialogData.clientData.ClientCountry\n                          "
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changedCountry(
          _vm.editClientDialogData.clientData.ClientCountry,
          'general'
        )
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                            " + _vm._s(country) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0025))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientState_Region
      ),
      expression: "\n                            editClientDialogData.clientData.ClientState_Region\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editClientDialogData.currentRegionsGeneral
        .length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientState_Region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editClientDialogData.currentRegionsGeneral
    .length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editClientDialogData.currentRegionsGeneral), function(region) {
    return _c('option', {
      key: region.Region,
      domProps: {
        "value": region.Region
      }
    }, [_vm._v("\n                            " + _vm._s(region.RegionName) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTimeZone"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientTimeZoneId
      ),
      expression: "\n                            editClientDialogData.clientData.ClientTimeZoneId\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editClientDialogData.currentTimeZonesGeneral
        .length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientTimeZoneId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editClientDialogData.currentTimeZonesGeneral
    .length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editClientDialogData.currentTimeZonesGeneral), function(tz) {
    return _c('option', {
      key: tz.TimeZoneId,
      domProps: {
        "value": tz.TimeZoneId
      }
    }, [_vm._v("\n                            " + _vm._s(tz.TimeZoneName) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientPostalCode
      ),
      expression: "\n                            editClientDialogData.clientData.ClientPostalCode\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPostalCode"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientPostalCode
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSinceClientMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputSinceClientMgmtEdit')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientSince
      ),
      expression: "\n                            editClientDialogData.clientData.ClientSince\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSinceClientMgmtEdit"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientSince
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAdditionalInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0031))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientAdditionalInfo
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientAdditionalInfo\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAdditionalInfo"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientAdditionalInfo
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientAdditionalInfo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingContact",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseContact",
      "aria-expanded": "false",
      "aria-controls": "collapseContact"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0032))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseContact",
      "role": "tabpanel",
      "aria-labelledby": "headingContact"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactFirstname"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientContactFirstName
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientContactFirstName\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputContactFirstname"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientContactFirstName
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactFirstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactLastname"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientContactLastName
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientContactLastName\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputContactLastname"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientContactLastName
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactLastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactPhone"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientContactPhone
      ),
      expression: "\n                            editClientDialogData.clientData.ClientContactPhone\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputContactPhone",
      "name": "inputContactPhone"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientContactPhone
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputContactPhone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputContactPhone')),
      expression: "inputHasError('inputContactPhone')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0091))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactFax"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0036))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientContactFax
      ),
      expression: "\n                            editClientDialogData.clientData.ClientContactFax\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputContactFax",
      "name": "inputContactFax"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientContactFax
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputContactFax')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactFax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputContactFax')),
      expression: "inputHasError('inputContactFax')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0092))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientContactEmail
      ),
      expression: "\n                            editClientDialogData.clientData.ClientContactEmail\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputContactEmail",
      "name": "inputContactEmail"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientContactEmail
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputContactEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputContactEmail')),
      expression: "inputHasError('inputContactEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0094))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingBillingDetail",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseBillingDetail",
      "aria-expanded": "false",
      "aria-controls": "collapseBillingDetail"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0038))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseBillingDetail",
      "role": "tabpanel",
      "aria-labelledby": "headingBillingDetail"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillTo"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillTo
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillTo\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillTo"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillTo
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillTo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingAddress\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingAddress"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0041))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress2
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingAddress2\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingAddress2"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress2
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0042))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillingCity
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillingCity\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingCity"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillingCity
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingCountry
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingCountry\n                          "
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changedCountry(
          _vm.editClientDialogData.clientData
          .ClientBillingCountry,
          'billing'
        )
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                            " + _vm._s(country) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0043))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingState_Region
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingState_Region\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editClientDialogData.currentRegionsBilling
        .length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingState_Region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editClientDialogData.currentRegionsBilling
    .length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editClientDialogData.currentRegionsBilling), function(region) {
    return _c('option', {
      key: region.Region,
      domProps: {
        "value": region.Region
      }
    }, [_vm._v("\n                            " + _vm._s(region.RegionName) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingPostalCode
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingPostalCode\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingPostalCode"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientBillingPostalCode
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillToEmail
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillToEmail\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputBillingEmail",
      "name": "inputBillingEmail"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillToEmail
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputBillingEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillToEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputBillingEmail')),
      expression: "inputHasError('inputBillingEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0094))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingTerms"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0047))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillingTerms
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillingTerms\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingTerms"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillingTerms
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingTerms", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingPersonalization",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapsePersonalization",
      "aria-expanded": "false",
      "aria-controls": "collapsePersonalization"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0048))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapsePersonalization",
      "role": "tabpanel",
      "aria-labelledby": "headingPersonalization"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLogoURL"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0049))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientPageLogoURL
      ),
      expression: "\n                            editClientDialogData.clientData.ClientPageLogoURL\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "id": "inputLogoURL",
      "name": "inputLogoURL"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientPageLogoURL
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLogoURL')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientPageLogoURL", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLogoURL')),
      expression: "inputHasError('inputLogoURL')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0093))])])])])]), _vm._v(" "), (
    _vm.selectedClient != -1 &&
    _vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingSurveys",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseSurveys",
      "aria-expanded": "false",
      "aria-controls": "collapseSurveys"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0059))])])]) : _vm._e(), _vm._v(" "), (
    _vm.selectedClient != -1 &&
    _vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseSurveys",
      "role": "tabpanel",
      "aria-labelledby": "headingSurveys"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar btn-top-dialog",
    attrs: {
      "type": "button",
      "disabled": _vm.editClientDialogData.selectedSurvey == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Read')
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = false),
        (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.C0107) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar btn-top-dialog",
    attrs: {
      "type": "button",
      "disabled": _vm.editClientDialogData.selectedSurvey == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Read') ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Update')
    },
    on: {
      "click": function($event) {
        return _vm.redirectToSurveyEditor(
          _vm.editClientDialogData.selectedSurvey
        )
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("playlist_add_check")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.C0108) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar btn-top-dialog",
    attrs: {
      "type": "button",
      "disabled": _vm.editClientDialogData.selectedSurvey == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Delete')
    },
    on: {
      "click": function($event) {
        _vm.showDeleteSurveyModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.C0109) + "\n                    ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0060) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0061) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editClientDialogData.clientData
    .Surveys), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.editClientDialogData.selectedSurvey ==
          survey.SurveyId,
      },
      on: {
        "click": function($event) {
          _vm.editClientDialogData.selectedSurvey =
            survey.SurveyId
        },
        "dblclick": function($event) {
          (_vm.editSurveyDialogModeAdd = false),
          (_vm.showEditSurveyDialog = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(survey.SurveyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(survey.SurveyTitle))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.selectedClient != -1) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCustProp",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseCustProp",
      "aria-expanded": "false",
      "aria-controls": "collapseCustProp"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0062))])])]) : _vm._e(), _vm._v(" "), (_vm.selectedClient != -1) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCustProp",
      "role": "tabpanel",
      "aria-labelledby": "headingCustProp"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCustProp"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0063))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClientDialogData.newCustomProperty),
      expression: "editClientDialogData.newCustomProperty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCustProp"
    },
    domProps: {
      "value": (_vm.editClientDialogData.newCustomProperty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData, "newCustomProperty", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addNewCustomProperty()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.C0064) + "\n                      ")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0065) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0066) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0103))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0067))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editClientDialogData.clientData
    .CustomProperties), function(property) {
    return _c('tr', {
      key: property.Position
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Name),
        expression: "property.Name"
      }],
      staticClass: "form-control text-center textarea-custom-properties autoExpand",
      staticStyle: {
        "margin": "0px"
      },
      attrs: {
        "rows": "1",
        "type": "text"
      },
      domProps: {
        "value": (property.Name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "Name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(property.Id))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "margin-right": "10px !important"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Visibility),
        expression: "property.Visibility"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(property, "Visibility", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(_vm.lang.C0104))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.lang.C0105))])])])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Position),
        expression: "property.Position"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(property, "Position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.reorderCustomProperties(property.Name)
        }]
      }
    }, _vm._l((_vm.editClientDialogData
      .clientData.CustomProperties), function(property2) {
      return _c('option', {
        key: property2.Position,
        domProps: {
          "value": property2.Position
        }
      }, [_vm._v("\n                                  " + _vm._s(property2.Position) + "\n                                ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "40%",
        "float": "left"
      }
    }, [(_vm.isCustomPropertyRemovable(property)) ? _c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openRemoveCustomPropertyDialog(property.Id)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("clear")])]) : _vm._e()])])])
  }), 0)])])]) : _vm._e()])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.editClientDialogData.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.editClientDialogData.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.C0068))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.C0069) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "client-management-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Clients_Update') &&
        _vm.editClientDialogData.dialogType == 'edit'
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editClient')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.C0070) + "\n            ")])])])])])]), _vm._v(" "), _c('SurveyManagementEditModal', {
    attrs: {
      "selectedSurvey": _vm.editClientDialogData.selectedSurvey,
      "selectedClient": _vm.selectedClientData,
      "showDialog": _vm.showEditSurveyDialog,
      "dialogModeAdd": _vm.editSurveyDialogModeAdd,
      "languageList": _vm.languageList,
      "localesList": _vm.localesList
    },
    on: {
      "surveyEditorRedirect": _vm.redirectToSurveyEditor,
      "dialogClosed": _vm.onEditSurveyDialogClosed,
      "dialogDataSaved": _vm.onEditSurveyDialogDataSaved
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "removeCustomPropertySecurityDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.C0110))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v(_vm._s(_vm.lang.C0111))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.lang.C0112) + "\n                "), _c('b', [_vm._v(_vm._s(_vm.removeCustomPropertySecurityDialogData.propName))]), _vm._v("\n                " + _vm._s(_vm.lang.C0113) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.C0114) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeCustomProperty(
          _vm.removeCustomPropertySecurityDialogData.propId
        )
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.C0115) + "\n          ")])])])])]), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "confirmationTitle": _vm.lang.C0116,
      "yesButtonText": _vm.lang.C0115,
      "noButtonText": _vm.lang.C0114,
      "showDialog": _vm.showDeleteSurveyModal,
      "colorRed": true
    },
    on: {
      "onYesConfirmation": _vm.deleteSurvey,
      "dialogClosed": function($event) {
        _vm.showDeleteSurveyModal = false
      }
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.C0117))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.C0019))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.editClientDialogData.selectedSurvey))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.C0098))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.getSelectedSurveyTitle()))])])]), _vm._v(" "), (_vm.feature.isEnabled('audi_importers')) ? _c('ImporterManagement', {
    attrs: {
      "showModal": _vm.showImportersModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showImportersModal = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9485686","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientManagement/ClientManagement.vue
// module id = 1736
// module chunks = 1